import useCustomHook from '@/hooks/useCustomHook';
import { createContext, useContext } from 'react';

export const ExpandedScreenContext = createContext({});

export function ExpandedScreenContextProvider({ children }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      active: false,
    },
    actions: {
      publicActions: {
        toggle: () => {
          actions.setState({
            active: !state.active,
          });
        },
        setActive: (active) => {
          actions.setState({
            active,
          });
        },
      },
    },
  });

  return (
    <ExpandedScreenContext.Provider
      value={{ state, actions: actions.publicActions }}
    >
      {children}
    </ExpandedScreenContext.Provider>
  );
}

export function useExpandedScreenContext() {
  return useContext(ExpandedScreenContext);
}
